import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../modules/shared/shared.module';
import { MaterialModule } from '../../../modules/shared/material/material.module';
import { MigrationNotificationModalComponent } from './migration-notification-modal.component';

@NgModule({
	declarations: [MigrationNotificationModalComponent],
	imports: [CommonModule, SharedModule, MaterialModule],
	exports: [MigrationNotificationModalComponent],
})
export class MigrationNotificationModalModule {}
